import curry from "../../lib/core/functional/curry";

export const EVENTS = {
    VOTE_ERROR: "voting::vote-error",
    VOTE_SUCCESS: "voting::vote-success",
    VOTE_CLEAR: "voting::clear-feedback",
    DISPLAY_RESULTS: "voting::display-results",
    VOTE_AGAIN: "voting::vote-again",
};

function emitError(listicle, error) {
    const event = new CustomEvent(EVENTS.VOTE_ERROR, { detail: error });
    listicle.dispatchEvent(event);
}

export const emitErrorFactory = curry(emitError);

export function clearFeedback(listicle) {
    listicle.dispatchEvent(new CustomEvent(EVENTS.VOTE_CLEAR));
}

export function getChoiceId(postId, choiceId) {
    return `listicle-voting-choice-${postId}-${choiceId}`;
}
